import { ProductAddCommandModel } from "../product-base-model";

export class MerchandizeAddCommandModel extends ProductAddCommandModel {
}